import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const footerAccordionData = [
  {
    id: "fcheck1",
    question: <b>Gateway Financial Services Limited</b>,
    content: (
      <>
        <p>
          CIN - U65999WB1994PLC065273 I SEBI Registration No.: INZ000247937 I
          Exchange Membership Codes: BSE – 3199 I NSE – 09344
        </p>
        <p>GATEWAY DERIVATIVES PVT LTD</p>
        <p>SEBI Registration No.: INZ000107234 I MCX Membership Code: 21705</p>
      </>
    ),
  },
  {
    id: "fcheck2",
    question: <b>Disclaimer &amp; Regulatory Information</b>,
    content: (
      <>
        <p>
          Equity: Investments in securities markets are subject to market risks.
          Read all related documents carefully before investing. Securities
          quoted are for illustration only and not recommendations.
        </p>
        <p>
          Mutual Funds: Mutual Fund investments are subject to market risks.
          Read all scheme-related documents carefully before investing.
        </p>
        <p>
          AMFI Registered Mutual Fund Distributor Codes: ARN-117053 – Gateway
          Financial Services Limited (Valid: 02-Apr-2025 to 01-Apr-2028)
        </p>
        <p>
          IPO: Opening of an account does not guarantee IPO allotment. Investors
          must conduct their own due diligence before investing.
        </p>
        <p>
          Margin Trading Facility (MTF): MTF is subject to SEBI Circular
          CIR/MRD/DP/54/2017 dated June 13, 2017 and terms specified in the
          Rights and Obligations document issued by GFSL.
        </p>
        <p>
          Research Analyst: Views expressed reflect the personal opinion of the
          analyst(s). Compensation is not linked directly or indirectly to
          specific recommendations. Advertisements comply with SEBI regulations.
        </p>
        <p>
          Certification: SEBI registration and NISM certification do not
          guarantee intermediary performance or investor returns.
        </p>
        <p>
          Trading Platform: GFSL has partnered with Synapsewave Innovations
          Private Limited for online and offline trading platform.
        </p>
        <p>
          By submitting any form, you provide explicit consent to be contacted
          by GFSL and its associate companies via phone call, SMS, email, or
          WhatsApp regarding products and services, even if registered under
          DND.
        </p>
      </>
    ),
  },
  {
    id: "fcheck3",
    question: <b>Attention Investors</b>,
    content: (
      <>
        <p>
          • For all communications related to vulnerability reporting, security
          alerts, or any other suspicious related to cyber security, contact our
          IT Helpdesk email id at{" "}
          <a href="mailto:itgateway@gatewayfin.in">itgateway@gatewayfin.in</a>{" "}
          /+91-033-22894461/62
        </p>
        <p>
          • For complaints related to Trading/Demat email at{" "}
          <a href="mailto:igrgateway@gatewayfin.in">igrgateway@gatewayfin.in</a>
        </p>
        <p>
          • Filing of complaints on
          <a
            href="https://scores.sebi.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            SCORES
          </a>{" "}
          - Easy &amp; quick:- a) Register on SCORES portal, b) Mandatory
          details for filing complaints on SCORES: Name, PAN, Address, Mobile
          Number, Email ID. Benefits:- a) Effective communication, b) Speedy
          redressal of the grievances
        </p>
        <p>
          • Stock Brokers can accept securities as margin only via pledge
          mechanism in the depository system (effective 1 September 2020).
        </p>
        <p>
          • Update mobile number &amp; email ID with broker/DP to receive OTP
          directly from depository on your email id and/or mobile number to
          create pledge.
        </p>
        <p>
          • Pay 20% upfront margin of transaction value for cash market trades.
        </p>
        <p>
          • Refer to relevant Exchange circulars (NSE/BSE) for margin and
          compliance guidelines.
        </p>
        <p>
          • Investors may please refer to the Exchange's Frequently Asked
          Questions (FAQs) issued vide circular reference NSE/INSP/45191 dated
          July 31, 2020 and NSE/INSP/45534 and BSE vide notice no. 20200731-7
          dated July 31, 2020 and 20200831-45 dated August 31, 2020 and other
          guidelines issued from time to time in this regard
        </p>
        <p>
          • Check your Securities/MF/Bonds in the Consolidated Account Statement
          issued by NSDL/CDSL every month.
        </p>
      </>
    ),
  },
  {
    id: "fcheck4",
    question: <b>Filing of complaints through SEBI's online portal 'SCORES' and 'SMARTODR portal' - Easy & Quick</b>,
    content: (
      <>
        <p>
          1. Register On SCORES/SMARTODR Portal
        </p>
        <p>2. Mandatory Details For filling Complaints on SCORES: (Name, PAN, Address, Mobile Number, Email ID)</p>
        <p>3. Benefits:</p>
        <p>i. Effective Communication</p>
        <p>ii. Speedy Redressal of Grievance / Dispute</p>
        <p><a href="http://scores.sebi.gov.in" target="_blank" rel="noreferrer">http://scores.sebi.gov.in</a></p>
        <p><a href="https://smartodr.in/login" target="_blank" rel="noreferrer">https://smartodr.in/login</a></p>
      </>
    ),
  },
];


const FooterAccordion = () => {
  const [openId, setOpenId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setOpenId(null);
  }, [location.pathname]);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="accordion-wrapper">
      {footerAccordionData.map((item, index) => {
        const isOpen = openId === item.id;

        return (
          <div className="accordion" key={item.id}>
            <button
              type="button"
              className="accordion-label text-dark"
              style={{
                borderTop: index === 0 ? 0 : undefined,
                background: "none",
                width: "100%",
                textAlign: "left",
                cursor: "pointer",
                border: "none",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => toggle(item.id)}
              aria-expanded={isOpen}
            >
              {item.question}
              <span
                className="accordion-icon"
                style={{
                  transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                &#10095;
              </span>
            </button>

            <div
              className="accordion-content"
              aria-hidden={!isOpen}
              style={{
                maxHeight: isOpen ? "100vh" : "0",
                padding: isOpen ? "5px 0px" : "0",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
            >
              {item.content}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FooterAccordion;
